import { EligibleForNpsSurvey, Survey, SurveyResponse, SurveyTranslation } from './types';
import merchantGatewayApi from '../api';

export const fetchEligibleForNpsSurvey = ({ venue_id }: { venue_id: string }) =>
  merchantGatewayApi
    .get<EligibleForNpsSurvey>('/merchant-analytics-api/users/current/eligible_for_nps_survey', {
      params: { venue_id },
    })
    .then(response => response.data);

export const dismissNpsSurvey = () =>
  merchantGatewayApi.post<null>('/merchant-analytics-api/surveys/nps/dismiss').then(response => response.data);

export const fetchNpsSurvey = () =>
  merchantGatewayApi.get<Survey>('/merchant-analytics-api/surveys/nps').then(response => response.data);

export const submitNpsSurvey = ({
  merchantId,
  venueId,
  surveyResponse,
}: {
  merchantId?: string | null;
  venueId?: string | null;
  surveyResponse: SurveyResponse;
}) =>
  merchantGatewayApi
    .post<Survey>('/merchant-analytics-api/surveys/nps/respond', {
      ...surveyResponse,
      merchantId,
      venueId,
    })
    .then(response => response.data);

export const fetchTranslationResource = ({ locale }: { locale: string }) =>
  merchantGatewayApi
    .get<SurveyTranslation>(`/merchant-analytics-api/surveys/nps/translations/${locale}`)
    .then(response => response.data);
